/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sklik_Token_HintInputs */

const cs_sklik_token_hint = /** @type {(inputs: Sklik_Token_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vygenerujte v Sklik → Nastavení → Přístup k API Drak. Vložte jednou; při úpravě ostatního nechte prázdné.`)
};

const en_sklik_token_hint = /** @type {(inputs: Sklik_Token_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Generate in Sklik → Settings → API Drak access. Paste once; leave empty when editing other settings.`)
};

/**
* | output |
* | --- |
* | "Generate in Sklik → Settings → API Drak access. Paste once; leave empty when editing other settings." |
*
* @param {Sklik_Token_HintInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const sklik_token_hint = /** @type {((inputs?: Sklik_Token_HintInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sklik_Token_HintInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_sklik_token_hint(inputs)
	return cs_sklik_token_hint(inputs)
});